import axios from "axios";
const iconMap = {
  // 默认
  default: {
    iconClass: "iconduoyun"
  },
  阴天: {
    iconClass: "iconyintian"
  },
  阴: {
    iconClass: "iconyintian"
  },
  大暴雨: {
    iconClass: "icondabaoyu"
  },
  暴雨到大暴雨: {
    iconClass: "icondabaoyu"
  },
  轻雾: {
    iconClass: "iconqingwu"
  },
  大雪: {
    iconClass: "icondaxue"
  },
  中到大雪: {
    iconClass: "icondaxue"
  },
  浮尘: {
    iconClass: "iconfuchen"
  },
  雷电: {
    iconClass: "iconleidian"
  },
  雾: {
    iconClass: "iconwu"
  },
  大雾: {
    iconClass: "iconwu"
  },
  小雪: {
    iconClass: "iconxiaoxue"
  },
  弱高吹雪: {
    iconClass: "iconxiaoxue"
  },
  多云: {
    iconClass: "iconduoyun"
  },
  扬沙: {
    iconClass: "iconyangsha"
  },
  晴: {
    iconClass: "iconqing"
  },
  雷阵雨: {
    iconClass: "iconleizhenyu"
  },
  雷阵雨伴有冰雹: {
    iconClass: "iconleizhenyu"
  },
  浓雾: {
    iconClass: "iconnongwu"
  },
  强浓雾: {
    iconClass: "iconnongwu"
  },
  特强浓雾: {
    iconClass: "iconnongwu"
  },
  中雨: {
    iconClass: "iconzhongyu"
  },
  小到中雨: {
    iconClass: "iconzhongyu"
  },
  龙卷风: {
    iconClass: "iconlongjuanfeng"
  },
  台风: {
    iconClass: "icontaifeng"
  },
  小雨: {
    iconClass: "iconxiaoyu"
  },
  沙尘暴: {
    iconClass: "iconshachenbao"
  },
  强沙尘暴: {
    iconClass: "iconshachenbao"
  },
  阵雪: {
    iconClass: "iconzhenxue"
  },
  雾霾: {
    iconClass: "iconwumai"
  },
  中度霾: {
    iconClass: "iconwumai"
  },
  重度霾: {
    iconClass: "iconwumai"
  },
  严重霾: {
    iconClass: "iconwumai"
  },
  特大暴雨: {
    iconClass: "icontedabaoyu"
  },
  大暴雨到特大暴雨: {
    iconClass: "icontedabaoyu"
  },
  阵雨: {
    iconClass: "iconzhenyu"
  },
  中雪: {
    iconClass: "iconzhongxue"
  },
  小到中雪: {
    iconClass: "iconzhongxue"
  },
  雨夹雪: {
    iconClass: "iconyujiaxue"
  },
  大风: {
    iconClass: "icondafeng"
  },
  暴雨: {
    iconClass: "iconbaoyu"
  },
  大到暴雨: {
    iconClass: "iconbaoyu"
  },
  冰雹: {
    iconClass: "iconbingbao"
  },
  暴雪: {
    iconClass: "iconbaoxue"
  },
  大到暴雪: {
    iconClass: "iconbaoxue"
  },
  大雨: {
    iconClass: "icondayu"
  },
  中到大雨: {
    iconClass: "icondayu"
  },
  冻雨: {
    iconClass: "icondongyu"
  }
};
/**
 * 获取天气图标
 * param: wea 天气数据
 */
function getWatherIcon(wea) {
  const keys = Object.keys(iconMap);
  const findKey = keys.find((v) => {
    return v === wea;
  });
  const firstFindKey = keys.find((v) => {
    return wea.indexOf(v) == 0;
  });
  const otherFindKey = keys.find((v) => {
    return wea.indexOf(v) >= 0;
  });
  if (findKey) {
    // 直接名称对应图标
    return iconMap[findKey].iconClass;
  } else if (firstFindKey) {
    // 首天气能找到天气能找到对应图标
    return iconMap[firstFindKey].iconClass;
  } else if (otherFindKey) {
    // 能找到天气能找到对应图标
    return iconMap[otherFindKey].iconClass;
  } else {
    return iconMap["default"].iconClass;
  }
}
/** 获取天气信息 */
export async function getWeatherData(areacode = '101180606') {
  axios.defaults.headers["X-APISpace-Token"] =
    "iqqznz4uhjjq06o597ivhvy1l09bddku";
  axios.defaults.headers["Authorization-Type"] = "apikey";
  axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
  axios.defaults.headers["User-Agent"] = "EOLINKER";
  axios.defaults.headers["Access-Cosntrol-Allow-Origin"] = "*";
  var weatherData = {};
  var icon = null;
  // 十五日预报
  await axios({
    method: "get",
    url: `/weatherApi/456456/weather/v001/day?days=15&areacode=${areacode}`
  }).then((res) => {
    if (res.data.status == 0) {
      weatherData = res.data.result.daily_fcsts || [];
      weatherData.forEach((e) => {
        e.icon = getWatherIcon(e.text_day);
      });
    } else {
      console.error("获取天气失败,code:", res.data.status);
    }
  });
  return { weatherData };
}
